/**
 * Remove cart items for protocol adherence checkout
 */
(function( $ ) {
		'use strict';

		//fire funcs when ready
		ready( removeAdherenceCartItemBtn );

		/**
		 * Detect if doc is ready and fire func inside
		 *
		 * @param fn
		 */
		function ready( fn ) {
			if ( document.attachEvent
					? document.readyState === 'complete'
					: document.readyState !== 'loading' ) {
				fn();
			} else {
				document.addEventListener( 'DOMContentLoaded', fn );
			}
		}

		/**
		 * Click event removing cart items for Adherences
		 */
		function removeAdherenceCartItemBtn() {
			let i;
			const removeAdhBtns = document.querySelectorAll( '.btn-remove-adh-item' );
			if ( removeAdhBtns === null ) {
				return;
			}

			for ( i = 0; i < removeAdhBtns.length; ++i ) {
				removeAdhBtns[ i ].addEventListener( 'click', function( e ) {
					e.preventDefault();
					removeAdhItemRow( e, this.getAttribute( 'data-adh-isda-id' ) );
				} );
			}
		}

		/**
		 * Upload click event triggers media library
		 *
		 * @param protocolId
		 */
		function removeAdhItemRow( e, adhIsdaId ) {
			var combineId   = '#cart-item-' + adhIsdaId,
			    itemRows    = document.querySelectorAll( '.cart-item-row' ), //why is this null?! >_<
			    //rowToRemove = document.getElementById( combineId );
			    //@todo: get the above vanilla JS working
			    rowToRemove = $( combineId );

			//@todo: get this working w/ vanilla
			//rowToRemove.parentNode.removeChild(rowToRemove);
			$.when( removeCartRow( rowToRemove ) ).then( function() {
				cartCount( itemRows, adhIsdaId );
				reCalculateTotal();
			} );
		}

		function reCalculateTotal() {
			let total = 0;
			const totalElems = document.querySelectorAll( 'input[name="_adh_price[]"]' );
			if ( totalElems.length ) {
				totalElems.forEach( elem => {
					total += parseInt( elem.value );
				} );
				document.getElementById( 'cart-total' ).textContent = total;
			}
		}

		//@todo: cart count needs to happen AFTER row removal
		function removeCartRow( row ) {
			row.remove();
		}

		function cartCount( rowsLeft, adhIsdaId ) {
			//@todo: This needs to be 0 but to move on, setting to 1
			if ( rowsLeft.length === 1 ) {
				//redirect back to management
				window.location.replace( '/protocols/manage' );
			} else {
				//update url with removed item
				var currentUrl  = window.location.href,
				    varToRemove = '&adherence%5B%5D=' + adhIsdaId,
				    newUrl      = currentUrl.replace( varToRemove, '' );

				history.pushState( null, null, newUrl );
			}
		}
	}
)( jQuery );